/* eslint-disable import-x/order */
import './set-webpack-path';
import 'util/Globals';

import {markInitialImportFinished} from 'util/StartImportTracker';
import markPageInitFinished from 'util/markPageInitFinished';

import ModelHubRouter from './RouterModelHub';
import mainRunner, {hotReload} from './util/MainRunner';

markInitialImportFinished();

if (process.env.NODE_ENV === 'development') {
  // Production build will skip this if block, preventing devInit from being bundled.
  const devInit = require('dev/devInit').default;
  devInit();
}

mainRunner([ModelHubRouter]);

// webpack HMR
if (module.hot) {
  module.hot.accept(['./RouterModelHub'], () => {
    const NextModelHubRouter = require('./RouterModelHub').default;
    hotReload([NextModelHubRouter]);
  });
}

markPageInitFinished();
